import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

import { SurfaceCard } from '@/components/SurfaceCard'
import { useAccountAppContext } from '@/app/AccountAppContext'

export const FatalError = () => {
    const { t } = useTranslation()

    const { bootstrapError, refreshBootstrap } = useAccountAppContext()

    const errorMessage = bootstrapError instanceof Error ? bootstrapError.message : t('messages.loadError')

    return (
        <div className="bg-account-page min-h-screen p-4 md:p-8">
            <div className="mx-auto max-w-3xl">
                <SurfaceCard title={t('states.fatalErrorTitle') || 'Service Unavailable'} description={errorMessage}>
                    <div className="flex items-center justify-between">
                        <div className="text-account-warning flex items-center gap-3 text-sm">
                            <ExclamationTriangleIcon className="h-5 w-5" />
                            500 / 503
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                void refreshBootstrap()
                            }}
                            className="bg-account-accent text-account-on-accent hover:bg-account-accent-hover rounded-lg px-5 py-2 text-sm font-semibold shadow-sm transition"
                        >
                            {t('common.retry') || 'Retry Configuration'}
                        </button>
                    </div>
                </SurfaceCard>
            </div>
        </div>
    )
}
